import React from 'react'
import SkeletonElement from './SkeletonElement'
import './Skeleton.css'
import {Row } from "shards-react";
import { Col, Card, CardHeader, CardBody } from "shards-react";
import SkeletonRow from './SkeletonRow';
import Shimmer from './Shimmer';


export default function SkeletonArticle() {
  return (
    <div className="skeleton-wrapper">
      <div className="skeleton-article">
        <Row>
          <Col>
            <Card small className="mb-4">
              <CardHeader className="border-bottom">
                <h6 className="m-0"><SkeletonElement type="text" /></h6>
              </CardHeader>
              <CardBody className="p-0 pb-3">
                <table className="table mb-0 bg-lightgray">
                  <thead className="bg-lightgray">
                    <tr>
                      <th scope="col" className="border-0">
                        <SkeletonElement type="title" />
                      </th>
                      <th scope="col" className="border-0">
                        <SkeletonElement type="title" />
                      </th>
                      <th scope="col" className="border-0">
                        <SkeletonElement type="title" />
                      </th>
                      <th scope="col" className="border-0">
                        <SkeletonElement type="title" />
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-lightgray">
                    {[1, 2, 3, 4, 5].map((n) => <SkeletonRow key={n} />
                    )
                    }
                  </tbody>
                </table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <Shimmer />
    </div>
  )
}
